
import React from 'react';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import {
    Container,
    Text
} from '../../../base/react';
import { connect } from '../../../base/redux';
import AbstractForceMuteEveryoneDialog, { type Props, abstractMapStateToProps }
    from '../AbstractForceMuteEveryoneDialog';

/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before disabling all remote participants cameras.
 *
 * @augments AbstractMuteEveryonesVideoDialog
 */
class ForceMuteEveryoneDialog extends AbstractForceMuteEveryoneDialog<Props> {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const audios = this.props._lockAudio;

        return (
            <Dialog
                okKey = { audios ? 'dialog.unforceMuteParticipantButton'
                    : 'dialog.forceMuteParticipantButton' }
                onSubmit = { this._onSubmit }
                titleString = { audios ? this.props.title1 : this.props.title }
                width = 'small'>
                <Container>
                    <Text>
                        { audios ? this.props.content2
                            : this.props.content }
                    </Text>
                </Container>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
}

export default translate(connect(abstractMapStateToProps)(ForceMuteEveryoneDialog));
